import React from 'react'
import PropTypes from 'prop-types'

import './Tag.scss'

const Tag = ({
  onClick,
  tag,
  selected,
  small,
}) => !tag.name ? null : (
    <div
      className={`tag ${selected ? 'selected-tag' : ''} ${small ? 'small-tag' : ''}`}
      onClick={onClick}
    >
      <span>{tag.name}</span>
    </div>
)

Tag.defaultProps = {
  onClick: null,
  selected: false,
  small: false,
}

Tag.propTypes = {
  tag: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  small: PropTypes.bool,
}

export default Tag



// WEBPACK FOOTER //
// ./src/browser/components/Tag.js